import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

/**
 * The state of a ContentItem's own Notes thread. `notesSummary` is null when
 * Notes are unavailable to the account, which is never an empty thread.
 *
 * The unread count is left out: read state for ContentItem Notes is not
 * shown yet.
 */
export const ContentItemNotesSummaryQuery = graphql(`
  query ContentItemNotesSummary($contentItemId: ContentItemId!) {
    contentItem(input: { id: $contentItemId }) {
      id
      notesSummary {
        totalCount
        isClosed
        canCreate
      }
    }
  }
`)

export type ContentItemNotesSummary = NonNullable<
  ResultOf<typeof ContentItemNotesSummaryQuery>['contentItem']['notesSummary']
>
